module.exports = __webpack_public_path__ + "app-static/img/ended.338d9a78.png";